// "Mohammed T. Abulhaija" -> first "Mohammed", last "T. Abulhaija" (nothing is dropped).
export const splitName = (full) => {
  const trimmed = (full || '').trim();
  if (!trimmed) return { first: '', last: '' };
  const [first, ...rest] = trimmed.split(/\s+/);
  return { first, last: rest.join(' ') };
};

export const joinName = (first, last) => [first, last].map((p) => (p || '').trim()).filter(Boolean).join(' ');

export const getArabicTexts = (formData) => {
  const ar = formData?.arabicContent || {};
  return {
    name: joinName(ar.firstName, ar.lastName),
    designation: ar.role || '',
    companyName: ar.companyName || '',
  };
};

// Returns a new formData with one Arabic field changed. The server only keeps
// arabicContent while arabicSupport is true, so it follows whether any field is filled.
export const applyArabicEdit = (formData, field, value) => {
  const arabicContent = { ...(formData?.arabicContent || {}) };

  if (field === 'name') {
    const { first, last } = splitName(value);
    arabicContent.firstName = first;
    arabicContent.lastName = last;
  } else if (field === 'designation') {
    arabicContent.role = value;
  } else if (field === 'companyName') {
    arabicContent.companyName = value;
  }

  const texts = getArabicTexts({ arabicContent });
  const hasAny = Boolean(texts.name || texts.designation || texts.companyName);

  return { ...formData, arabicContent, arabicSupport: hasAny };
};
